import Http from 'axios'
import {API_URL, BASE_TOKEN, VERSION} from '../config/config'
import store from '../store/index'

export default {
    user: null,
    destroySession() {
        this.user = null
    },
    async currentUser() {
        if (this.user) {
            return this.user
        }
        try {
            let user = await Http.get(API_URL + VERSION + '/user');
            this.user = user;
            store.commit('AuthUser/setUser', user.data.data);
            return user
        } catch (error) {
            if (error.response.status === 401) {
                window.localStorage.clear();
                window.location.href = '/admin/system/login'
            }
            return error
        }
    },
    async attemptReset(credentials) {

        try {
            const response = await Http.post(API_URL + VERSION + '/password/reset', credentials);
            return new Promise(resolve => resolve(response))
        } catch (error) {
            return new Promise(reject => reject(error))
        }
    },
    async attemptLogin(credentials) {
        try {
            return await Http.post(BASE_TOKEN + '/oauth/token', credentials,);
        } catch (error) {
            throw error;
        }
    },
    async attemptCheck2FAEnabled(credentials) {
        try {
            return await Http.post(API_URL + VERSION + '/check-2fa-enabled', credentials,);
        } catch (error) {
            throw error;
        }
    },
    async validate2FAToken(credentials) {
        try {
            return await Http.post(API_URL + VERSION + '/validate-2fa-token', credentials,);
        } catch (error) {
            throw error;
        }
    },
    addAuthorizationHeader(header) {
        Http.defaults.headers.common['Authorization'] = header
    }
}
